import Settings from 'configs/Settings';
import UserStore from 'modules/user/UserStore';

import {
  DEFAULT_EVENT_PROPS,
  EVENT_ACTIONS,
  EVENT_PROPS,
  SYSTEMS
} from './constants';
import DatahubServiceUtil from './DatahubService.util';

import EventAgent from '@hotmart/event-agent-js';

EventAgent.mode = Settings.isProduction() ? 'production' : 'staging';

class DatahubService {
  constructor() {
    this.system = SYSTEMS.APP_CLUB_ADMIN;
    this.analyticsEventBuilder = DatahubServiceUtil.analyticsEventBuilder;
  }

  setSystem = (isMembership = false) => {
    this.system = isMembership
      ? SYSTEMS.APP_MEMBERSHIP_ADMIN
      : SYSTEMS.APP_CLUB_ADMIN;
  };

  setAnalyticsEventBuilder = (analyticsEventBuilder) => {
    this.analyticsEventBuilder = analyticsEventBuilder;
  };

  async sendMetrify(event, options = {}) {
    const { name, group } = event || {};
    const isValidEvent = name && group;

    if (!isValidEvent) {
      // eslint-disable-next-line no-console
      console.error('Invalid datahub event', event);
      return;
    }

    const { marketplaceId: userId } = UserStore;

    EventAgent.sendMetrify({
      system: options?.system || this.system,
      event: {
        name: event.name,
        group: event.group,
        user: userId ? { id: userId } : { id: 0 },
        ...(event.params && { params: event.params })
      }
    });
  }

  sendPageViewEvent(prevLocation, curLocation) {
    const event = DatahubServiceUtil.getEventData(prevLocation, curLocation);
    const eventData = {
      ...EVENT_PROPS[EVENT_ACTIONS.NAVIGATE],
      system: this.system
    };

    if (!eventData) {
      throw new Error(
        `Invalid datahub action. Received: ${EVENT_ACTIONS.NAVIGATE}`
      );
    }

    eventData.event = event;
    EventAgent.send(eventData);
  }

  sendEvent({ action, event = {} }) {
    const eventData = {
      system: this.system,
      entity: 'user',
      action: action || EVENT_ACTIONS.NAVIGATE,
      ...DEFAULT_EVENT_PROPS,
      event
    };

    EventAgent.send(eventData);
  }

  sendTrackEvent({ action, event = {} }) {
    const eventData = {
      system: SYSTEMS.APP_CLUB_ADMIN,
      entity: 'learning_track',
      action,
      event
    };

    EventAgent.send(eventData);
  }
}

export default new DatahubService();
